__turbopack_context__.v({
  "arcade-blink": "S7nbIq_arcade-blink",
  "arrowButton": "S7nbIq_arrowButton",
  "blinker": "S7nbIq_blinker",
  "bonusConsent": "S7nbIq_bonusConsent",
  "button": "S7nbIq_button",
  "cabinet": "S7nbIq_cabinet",
  "card": "S7nbIq_card",
  "claimConsent": "S7nbIq_claimConsent",
  "claimForm": "S7nbIq_claimForm",
  "claimNote": "S7nbIq_claimNote",
  "claimStatus": "S7nbIq_claimStatus",
  "claimStatusError": "S7nbIq_claimStatusError",
  "claimStatusOk": "S7nbIq_claimStatusOk",
  "coinOverlay": "S7nbIq_coinOverlay",
  "credits": "S7nbIq_credits",
  "dropButton": "S7nbIq_dropButton",
  "foot": "S7nbIq_foot",
  "goalNote": "S7nbIq_goalNote",
  "goldCard": "S7nbIq_goldCard",
  "goldTitle": "S7nbIq_goldTitle",
  "guide": "S7nbIq_guide",
  "guideButton": "S7nbIq_guideButton",
  "guideHead": "S7nbIq_guideHead",
  "guideTitle": "S7nbIq_guideTitle",
  "header": "S7nbIq_header",
  "headerText": "S7nbIq_headerText",
  "headline": "S7nbIq_headline",
  "hint": "S7nbIq_hint",
  "inkButton": "S7nbIq_inkButton",
  "mainCanvas": "S7nbIq_mainCanvas",
  "miniGif": "S7nbIq_miniGif",
  "muteButton": "S7nbIq_muteButton",
  "mutedText": "S7nbIq_mutedText",
  "outlineButton": "S7nbIq_outlineButton",
  "overlay": "S7nbIq_overlay",
  "pad": "S7nbIq_pad",
  "previewCanvas": "S7nbIq_previewCanvas",
  "previewCanvasGlow": "S7nbIq_previewCanvasGlow",
  "privacyLink": "S7nbIq_privacyLink",
  "redButton": "S7nbIq_redButton",
  "redText": "S7nbIq_redText",
  "resultOverlay": "S7nbIq_resultOverlay",
  "rewardGif": "S7nbIq_rewardGif",
  "root": "S7nbIq_root",
  "subtitle": "S7nbIq_subtitle",
});
